import {Calculator, Home} from 'lucide-react'
import { Link } from 'react-router-dom'
import Seo from '@/components/Seo'

function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found"
        description="The page you are looking for could not be found on Mint Calculator."
        path="/404"
      />
      <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-4 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-400">
          <Calculator className="h-7 w-7" />
        </span>
        <p className="mt-6 font-mono text-6xl font-bold text-slate-100">404</p>
        <h1 className="mt-2 text-xl font-semibold text-slate-200">Page not found</h1>
        <p className="mt-2 text-sm text-slate-500">
          The calculator or page you're looking for doesn't exist or may have moved.
        </p>
        <Link to="/" className="mt-6 flex items-center gap-2 rounded-lg bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-slate-950 transition-colors hover:bg-emerald-400">
          <Home className="h-4 w-4" />
          Back to Home
        </Link>
      </div>
    </>
  )
}

export default NotFound
